<template>
	<div>
		<h1>Szilenciumok lefoglalása</h1>
		<v-row>
			<v-col cols="12" sm="11">
				<v-menu
		      v-model="hetfovalaszto.menu"
		      :close-on-content-click="false"
		      transition="scale-transition"
		      offset-y
		      min-width="290px"
		    >
		      <template v-slot:activator="{ on, attrs }">
		        <v-text-field
		          v-model="hetfovalaszto.datum"
		          label="Hét kezdőnapja"
		          prepend-inner-icon="fa-calendar"
		          readonly
		          v-bind="attrs"
		          v-on="on"
		        ></v-text-field>
		      </template>
		      <v-date-picker
		        v-model="hetfovalaszto.datum"
		        no-title
		        scrollable
						:allowed-dates="hetfok"
						first-day-of-week="1"
						@input="hetfovalaszto.menu=false, tablazatfrissitese()"
		      >
		      </v-date-picker>
		    </v-menu>
			</v-col>
			<v-col cols="12" sm="1">
				<v-tooltip top>
					<template v-slot:activator="{on, attrs}">
						<v-btn fab v-bind="attrs" v-on="on" color="success" @click="ujfoglalasdialogus.mutat=true"><v-icon>fa-user-times</v-icon></v-btn>
					</template>
					Új foglalás
				</v-tooltip>
			</v-col>
		</v-row>
		<v-row class="justify-center">
			Színmagyarázat:
			<v-chip color="success">Teljes kollégium</v-chip>
			<v-chip color="warning">Csoport</v-chip>
			<v-chip color="primary">Tanuló</v-chip>
		</v-row>
		<v-data-table
			:headers="tablazat.fejlecek"
			:items="adatok.szilenciumok"
			sort-by="szam"
		>

			<template v-slot:item.szam="{item}">
				{{item.szam}}. szilencium ({{item.idopont}})
			</template>

			<template v-slot:item.hetfo="{item}">
				<v-tooltip top v-for="foglalas in adatok.foglalasok.filter(f => f.foglaltszilenciumid==item.id&&f.foglaltnap==hettetszolegesnapja(0))"  :key="foglalas.id">
					<template v-slot:activator="{on, attrs}">

						<v-chip :close="$store.state.minosites==-2||foglalas.foglaloid==$store.state.id" @click:close="foglalastorlese(foglalas.id)" v-bind="attrs" v-on="on" :color="foglalas.foglalasmerteke==0? 'success' : (foglalas.foglalasmerteke==1 ? 'warning' : 'primary')">
							<v-icon left v-if="foglalas.jelolesnekminosulo===true||foglalas.jelolesnekminosulo==1">fa-check</v-icon>
							{{foglalas.foglalasmerteke==0 ? "Teljes kollégium" : (foglalas.foglalasmerteke==1 ? (adatok.csoportok.find(cs => cs.id==foglalas.foglaltid).csoportnev+" (Csoportvezető: "+adatok.felhasznalok.find(f => f.id==adatok.csoportok.find(cs => cs.id==foglalas.foglaltid).csoportvezetoid).nev+")") : (adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).nev + (adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).csoportid ? " ("+adatok.csoportok.find(cs => cs.id==adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).csoportid).csoportnev+")":"") ))}}
						</v-chip>
					</template>
					<span>Foglaló: {{adatok.felhasznalok.find(f=> f.id==foglalas.foglaloid).nev}}, Megjegyzés: {{foglalas.foglalasmegjegyzes}}</span>
				</v-tooltip>
			</template>
			<template v-slot:item.kedd="{item}">
				<v-tooltip top v-for="foglalas in adatok.foglalasok.filter(f => f.foglaltszilenciumid==item.id&&f.foglaltnap==hettetszolegesnapja(1))"  :key="foglalas.id">
					<template v-slot:activator="{on, attrs}">

						<v-chip :close="$store.state.minosites==-2||foglalas.foglaloid==$store.state.id" @click:close="foglalastorlese(foglalas.id)" v-bind="attrs" v-on="on" :color="foglalas.foglalasmerteke==0? 'success' : (foglalas.foglalasmerteke==1 ? 'warning' : 'primary')">
							{{foglalas.foglalasmerteke==0 ? "Teljes kollégium" : (foglalas.foglalasmerteke==1 ? (adatok.csoportok.find(cs => cs.id==foglalas.foglaltid).csoportnev+" (Csoportvezető: "+adatok.felhasznalok.find(f => f.id==adatok.csoportok.find(cs => cs.id==foglalas.foglaltid).csoportvezetoid).nev+")") : (adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).nev + (adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).csoportid ? " ("+adatok.csoportok.find(cs => cs.id==adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).csoportid).csoportnev+")":"") ))}}
						</v-chip>
					</template>
					<span>Foglaló: {{adatok.felhasznalok.find(f=> f.id==foglalas.foglaloid).nev}}, Megjegyzés: {{foglalas.foglalasmegjegyzes}}</span>
				</v-tooltip>
			</template>
			<template v-slot:item.szerda="{item}">
				<v-tooltip top v-for="foglalas in adatok.foglalasok.filter(f => f.foglaltszilenciumid==item.id&&f.foglaltnap==hettetszolegesnapja(2))"  :key="foglalas.id">
					<template v-slot:activator="{on, attrs}">

						<v-chip :close="$store.state.minosites==-2||foglalas.foglaloid==$store.state.id" @click:close="foglalastorlese(foglalas.id)" v-bind="attrs" v-on="on" :color="foglalas.foglalasmerteke==0? 'success' : (foglalas.foglalasmerteke==1 ? 'warning' : 'primary')">
							{{foglalas.foglalasmerteke==0 ? "Teljes kollégium" : (foglalas.foglalasmerteke==1 ? (adatok.csoportok.find(cs => cs.id==foglalas.foglaltid).csoportnev+" (Csoportvezető: "+adatok.felhasznalok.find(f => f.id==adatok.csoportok.find(cs => cs.id==foglalas.foglaltid).csoportvezetoid).nev+")") : (adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).nev + (adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).csoportid ? " ("+adatok.csoportok.find(cs => cs.id==adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).csoportid).csoportnev+")":"") ))}}
						</v-chip>
					</template>
					<span>Foglaló: {{adatok.felhasznalok.find(f=> f.id==foglalas.foglaloid).nev}}, Megjegyzés: {{foglalas.foglalasmegjegyzes}}</span>
				</v-tooltip>
			</template>
			<template v-slot:item.csutortok="{item}">
				<v-tooltip top v-for="foglalas in adatok.foglalasok.filter(f => f.foglaltszilenciumid==item.id&&f.foglaltnap==hettetszolegesnapja(3))"  :key="foglalas.id">
					<template v-slot:activator="{on, attrs}">

						<v-chip :close="$store.state.minosites==-2||foglalas.foglaloid==$store.state.id" @click:close="foglalastorlese(foglalas.id)" v-bind="attrs" v-on="on" :color="foglalas.foglalasmerteke==0? 'success' : (foglalas.foglalasmerteke==1 ? 'warning' : 'primary')">
							{{foglalas.foglalasmerteke==0 ? "Teljes kollégium" : (foglalas.foglalasmerteke==1 ? (adatok.csoportok.find(cs => cs.id==foglalas.foglaltid).csoportnev+" (Csoportvezető: "+adatok.felhasznalok.find(f => f.id==adatok.csoportok.find(cs => cs.id==foglalas.foglaltid).csoportvezetoid).nev+")") : (adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).nev + (adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).csoportid ? " ("+adatok.csoportok.find(cs => cs.id==adatok.felhasznalok.find(f => f.id==foglalas.foglaltid).csoportid).csoportnev+")":"") ))}}
						</v-chip>
					</template>
					<span>Foglaló: {{adatok.felhasznalok.find(f=> f.id==foglalas.foglaloid).nev}}, Megjegyzés: {{foglalas.foglalasmegjegyzes}}</span>
				</v-tooltip>
			</template>

		</v-data-table>
		<v-dialog
				v-model="ujfoglalasdialogus.mutat"
				persistent
				max-width="600px"
		>

				<v-card>
					<v-card-title>
						<span class="headline">Új foglalás</span>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-menu
					      v-model="ujfoglalasdialogus.datumvalasztomenu"
					      :close-on-content-click="false"
					      transition="scale-transition"
					      offset-y
					      min-width="290px"
					    >
					      <template v-slot:activator="{ on, attrs }">
					        <v-text-field
					          v-model="ujfoglalasdialogus.foglalas.foglaltnap"
					          label="Nap"
					          prepend-inner-icon="fa-calendar"
					          readonly
					          v-bind="attrs"
					          v-on="on"
					        ></v-text-field>
					      </template>
					      <v-date-picker
					        v-model="ujfoglalasdialogus.foglalas.foglaltnap"
					        no-title
					        scrollable
									first-day-of-week="1"
									:allowed-dates="nemhetvege"
									@input="ujfoglalasdialogus.datumvalasztomenu=false"
					      >
					      </v-date-picker>
					    </v-menu>
						<v-checkbox
								v-model="ujfoglalasdialogus.mindenszilencium"
								label="Egész napos foglalás"
							/>
							<v-select
								v-if="!ujfoglalasdialogus.mindenszilencium"
								prepend-inner-icon="fa-business-time"
								label="Szilencium"
								:items="adatok.szilenciumok"
								v-model="ujfoglalasdialogus.foglalas.foglaltszilenciumid"
								item-value="id"
								item-text="szam"
							>
								<template v-slot:item="{item}">
									{{item.szam}}. szilencium ({{item.idopont}})
								</template>
							</v-select>
							<v-select
								prepend-inner-icon="fa-users"
								label="Foglalás mértéke"
								:items="$store.state.minosites==-2? [{v: 0, t: 'Teljes kollégium'}, {v: 1, t: 'Egy csoport'}, {v: 2, t: 'Egy tanuló'}] : [{v: 1, t: 'Egy csoport'}, {v: 2, t: 'Egy tanuló'}]"
								v-model="ujfoglalasdialogus.foglalas.foglalasmerteke"
								item-value="v"
								item-text="t"
							></v-select>
							<v-select
								v-if="ujfoglalasdialogus.foglalas.foglalasmerteke>0&&adatok.felhasznalok&&adatok.csoportok"
								:prepend-inner-icon="ujfoglalasdialogus.foglalas.foglalasmerteke==1 ? 'fa-users' : 'fa-user'"
								:label="ujfoglalasdialogus.foglalas.foglalasmerteke==1 ? 'Lefoglalandó csoport' : 'Lefoglalandó felhasználó'"
								:items="ujfoglalasdialogus.foglalas.foglalasmerteke==1 ? ($store.state.minosites==-2 ? adatok.csoportok : adatok.csoportok.filter(cs => cs.csoportvezetoid==$store.state.id)) : adatok.felhasznalok.filter(f => f.minosites>=0)"
								v-model="ujfoglalasdialogus.foglalas.foglaltid"
								item-value="id"
								:item-text="ujfoglalasdialogus.foglalas.foglalasmerteke==1 ? 'csoportnev' : 'nev'"
							>
								<template v-slot:item="{item}" v-if="ujfoglalasdialogus.foglalas.foglalasmerteke==2">
									{{item.nev}} {{item.csoportid? "("+adatok.csoportok.find(cs => cs.id==item.csoportid).csoportnev+")":""}}
								</template>
								<template v-slot:item="{item}" v-else-if="ujfoglalasdialogus.foglalas.foglalasmerteke==1">
									{{item.csoportnev}} (Csoportvezető: {{adatok.felhasznalok.find(f => f.id==item.csoportvezetoid).nev}})
								</template>
							</v-select>
							<v-text-field
								prepend-inner-icon="fa-comment"
								label="Megjegyzés"
								v-model="ujfoglalasdialogus.foglalas.foglalasmegjegyzes"
							></v-text-field>
							<v-checkbox
								label="Szilenciumjelölésnek minősül (a tanulónak foglalásonként 1-gyel kevesebbet kell jelölnie az adott napon)"
								v-model="ujfoglalasdialogus.foglalas.jelolesnekminosulo"
							/>
							<v-checkbox
								v-model="ujfoglalasdialogus.mezoktorlese"
								label="Mezők törlése"
							/>
							<v-checkbox
								v-model="ujfoglalasdialogus.tomegeshozzaadas"
								label="Tömeges foglalás"
							/>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="ujfoglalasdialogus.mutat=false"
						>
							Mégsem<v-icon>fa-times</v-icon>
						</v-btn>
						<v-btn
							color="success"
							text
							v-if="adatok.felhasznalok&&adatok.csoportok ? (ujfoglalasdialogus.foglalas.foglaltszilenciumid>-1 || ujfoglalasdialogus.mindenszilencium)&&ujfoglalasdialogus.foglalas.foglalasmerteke==0? true : (ujfoglalasdialogus.foglalas.foglalasmerteke==1 ? adatok.csoportok.findIndex(cs => cs.id==ujfoglalasdialogus.foglalas.foglaltid)!=-1 : adatok.felhasznalok.findIndex(f => f.id==ujfoglalasdialogus.foglalas.foglaltid)!=-1) : false"
							@click="ujfoglalas"
						>
							Foglalás<v-icon>fa-user-times</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card><!--Új szoba-->
		</v-dialog>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
				snackbar: {
					megnyit: false,
					szoveg: ""
				},
				ujfoglalasdialogus: {
					mutat: false,
					datumvalasztomenu: false,
					foglalas: {
						foglaltnap: this.aktualishetfo(),
						foglaltszilenciumid: -1,
						foglalasmerteke: 2,
						foglaltid: 0,
						foglalasmegjegyzes: "",
						jelolesnekminosulo: false,
					},
					mindenszilencium: false,
					mezoktorlese: false,
					tomegeshozzaadas: false
				},
				hetfovalaszto: {
					menu: false,
					datum: this.aktualishetfo()
				},
				tablazat: {
					fejlecek: [
						{
							text: "Szilencium",
							value: "szam",
							align: "center",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Hétfő",
							value: "hetfo",
							align: "center",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Kedd",
							value: "kedd",
							align: "center",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Szerda",
							value: "szerda",
							align: "center",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Csütörtök",
							value: "csutortok",
							align: "center",
							sortable: false,
							filterable: false,
							groupable: false
						}
					]
				},
				adatok: {}
			}
		},
		computed: {
			hetfo() {
				return this.hetfovalaszto.datum;
			}

		},
		watch: {
			hetfo(val) {
				this.ujfoglalasdialogus.foglalas.foglaltnap=val;
			}
		},
		methods: {
			ujfoglalas: function() {
				if(this.ujfoglalasdialogus.mindenszilencium) {
					this.ujfoglalasdialogus.foglalas.foglaltszilenciumid=-2;
				}
				this.axios.post(this.$store.state.backendeleres+"szilenciumfoglalas/",this.ujfoglalasdialogus.foglalas)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.adatok.foglalasok.push({...this.ujfoglalasdialogus.foglalas, id: response.data.id, foglaloid: this.$store.state.id})
											this.snackbar.szoveg="A foglalás sikeresen megtörtént."
											this.snackbar.megnyit=true;
											this.ujfoglalasdialogus.mutat=this.ujfoglalasdialogus.tomegeshozzaadas?true:false;
											if(this.ujfoglalasdialogus.mezoktorlese) {
													this.ujfoglalasdialogus.foglalas.foglaltnap= this.hetfovalaszto.datum;
													this.ujfoglalasdialogus.foglalas.foglaltszilenciumid= -1;
													this.ujfoglalasdialogus.foglalas.foglalasmerteke= 2;
													this.ujfoglalasdialogus.foglalas.foglaltid= 0;
													this.ujfoglalasdialogus.foglalas.foglalasmegjegyzes= "";
													this.ujfoglalasdialogus.foglalas.jelolesnekminosulo=false;
											}
											if(this.ujfoglalasdialogus.mindenszilencium) {
												this.tablazatfrissitese()
											}
										}
										else{
											this.snackbar.szoveg="A foglalás hibába ütközött: "+response.data.hiba
											this.snackbar.megnyit=true;
										}
									})
			},
			foglalastorlese: function(foglalasid) {
				this.axios.delete(this.$store.state.backendeleres+"szilenciumfoglalas/"+foglalasid)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.adatok.foglalasok.splice(this.adatok.foglalasok.findIndex(f => f.id==foglalasid),1);
											this.snackbar.szoveg="A törlés sikeresen megtörtént."
											this.snackbar.megnyit=true;
										}
										else {
											this.snackbar.szoveg="A törlés hibába ütközött: "+response.data.hiba
											this.snackbar.megnyit=true;
										}
									})
			},
			tablazatfrissitese: function() {
				this.axios.get(this.$store.state.backendeleres+"szilenciumfoglalas/"+this.hetfovalaszto.datum)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) this.adatok=response.data.adatok;
									})
			},
			aktualishetfo: () => {var d = new Date(); var r = new Date(d.setDate(d.getDate()-d.getDay()+(d.getDay() == 0 ? -6:1))); return r.toISOString().substring(0,10)},
			hetfok: nap => new Date(Date.parse(nap)).getDay()==1,
			nemhetvege: nap => new Date(Date.parse(nap)).getDay()<5&&new Date(Date.parse(nap)).getDay()>0,
			hettetszolegesnapja: function(nap /*0: hétfő, 1: kedd*/)  {
				var datum = new Date(Date.parse(this.hetfovalaszto.datum))
				datum.setDate(datum.getDate()+nap)
				return datum.toISOString().substring(0,10)
			}
		},
		mounted(){
			this.tablazatfrissitese()
		}
	}
</script>
